export const API_QUERIES = {
  categories: (grade_id?: string | null) => ["categories", grade_id],
  grades: ["grades"],
  article: (url?: string) => ["articles", url],
  hierarchy: (grade_id?: string | null) => ["hierarchy", grade_id],
  blaze_query: (
    query: string,
    subject_name: string,
    chapter_name: string,
    syllabus: string
  ) => ["blaze-query", query, subject_name, chapter_name, syllabus],
  blaze_lecture_recommendation: (query: string) => [
    "blaze-lecture-recommendation",
    query,
  ],
};
